export default {"src":"/_next/static/media/HES.b8e2e157.svg","height":18,"width":18};